export const MEDIA_DOCK_CINEMA_FEATURE = 'media_dock_cinema'

export function mediaDockCinemaEnabled(): boolean {
    return true
}

type CinemaReturnPresentationOptions = {
    mediaKey: string
    takeoverMediaKey?: string | null
    hostedMediaKey?: string | null
    isPresented: boolean
    isExpanded: boolean
}

export type CinemaReturnPresentation = 'expanded' | 'hosted' | 'corner' | 'none'

export function getCinemaReturnPresentation({
    mediaKey,
    takeoverMediaKey,
    hostedMediaKey,
    isPresented,
    isExpanded,
}: CinemaReturnPresentationOptions): CinemaReturnPresentation {
    const dockPresentsRequestedTrack = takeoverMediaKey === mediaKey && isPresented
    if (isExpanded && dockPresentsRequestedTrack) return 'expanded'
    if (hostedMediaKey === mediaKey) return 'hosted'
    if (dockPresentsRequestedTrack) return 'corner'
    return 'none'
}
